export const GO_TO_PROFILE_LABEL = 'button.label.go.to.profile';
